import styled from "@emotion/styled";

import { space } from "metabase/styled-components/theme";
import Button from "metabase/core/components/Button/Button";

export const ApplyButton = styled(Button)`
  margin-left: auto;
  margin-top: ${space(1)};
`;
